import { render, staticRenderFns } from "./CpRequestAlert.vue?vue&type=template&id=0b86bf57&scoped=true&"
import script from "./CpRequestAlert.vue?vue&type=script&lang=js&"
export * from "./CpRequestAlert.vue?vue&type=script&lang=js&"
import style0 from "./CpRequestAlert.vue?vue&type=style&index=0&id=0b86bf57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86bf57",
  null
  
)

export default component.exports